import { render, staticRenderFns } from "./PopupProjectSetting.vue?vue&type=template&id=5976b1d3&scoped=true&"
import script from "./PopupProjectSetting.vue?vue&type=script&lang=js&"
export * from "./PopupProjectSetting.vue?vue&type=script&lang=js&"
import style0 from "./PopupProjectSetting.vue?vue&type=style&index=0&id=5976b1d3&prod&scoped=true&lang=css&"
import style1 from "./PopupProjectSetting.vue?vue&type=style&index=1&id=5976b1d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976b1d3",
  null
  
)

export default component.exports